/* eslint-disable */

/**
 * updated at 2021-09-10 15:51:08
 * */

export default {
  /** 对话框挂载的节点，默认挂在组件本身的位置。数据类型为 String 时，会被当作选择器处理，进行节点查询。示例：'body' 或 () => document.body */
  attach: {
    type: [String, Function],
    default: '',
  },
  /** 对话框内容 */
  body: {
    type: [String, Function],
    default: '',
  },
  /** 设置弹窗总体样式,包含背景图和背景色 */
  dialogStyle: {
    type: [Object],
    default: () => {},
  },
  /** 取消按钮，可自定义。值为 undefined 或 null 则不显示取消按钮。值类型为 Object 则表示透传 Button 组件属性 */
  cancelBtn: {
    type: [String, Object, Function],
    default: null,
  },
  cancelStyle: {
    type: [Object],
    default: () => {},
  },
  /** 关闭按钮，可以自定义。值为 true 显示默认关闭按钮，值为 false 不显示关闭按钮。值类型为 string 则直接显示值，如：“关闭”。值类型为 TNode，则表示呈现自定义按钮示例 */
  closeBtn: {
    type: [String, Boolean, Function],
    default: true,
  },
  closeStyle: {
    type: [Object],
    default: () => {},
  },
  /** 关闭按钮显示位置，可以自定义。'bottom-center'表示底部居中,'top-right'表示顶部靠右 */
  closeLocation: {
    type: String,
    default: 'bottom-center',
  },
  /** 按下 ESC 时是否触发抽屉关闭事件 */
  closeOnEscKeydown: {
    type: Boolean,
    default: false,
  },
  /** 点击蒙层时是否触发关闭事件 */
  closeOnOverlayClick: {
    type: Boolean,
    default: false,
  },
  /** 确认按钮，可自定义。值为 undefined 或 null 则不显示确认按钮 */
  confirmBtn: {
    type: [String, Object, Function],
    default: null,
  },
  confirmStyle: {
    type: [Object],
    default: () => {},
  },
  /** 抽屉内容，同 body */
  default: {
    type: [String, Function],
  },
  /** 是否在关闭弹框的时候销毁子元素 */
  destroyOnClose: Boolean,
  /** 对话框是否可以拖拽（仅在非模态对话框时有效） */
  draggable: Boolean,
  /** 底部操作栏，默认会有“确认”和“取消”两个按钮。值为 true 显示默认操作按钮，值为 false 不显示任何内容，值类型为 Function 表示自定义底部内容 */
  footer: {
    type: [Boolean, Function],
    default: true,
  },
  /** 头部内容。值为 true 显示空白头部，值为 false 不显示任何内容，值类型为 string 则直接显示值，值类型为 Function 表示自定义头部内容 */
  header: {
    type: [String, Boolean, Function],
    default: true,
  },
  /** 对话框类型，有三种：模态对话框、非模态对话框和普通对话框。弹出「模态对话框」时，只能操作对话框里面的内容，不能操作其他内容。弹出「非模态对话框」时，则可以操作页面内所有内容。「普通对话框」是指没有脱离文档流的对话框，可以在这个基础上开发更多的插件 */
  mode: {
    type: String,
    default: 'modal',
    validator(val) {
      return ['modal', 'modeless', 'normal'].includes(val);
    },
  },
  /** 对话框位置，内置两种：垂直水平居中显示 和 靠近顶部（top:20%）显示 */
  placement: {
    type: String,
    default: 'top',
    validator(val) {
      return ['top', 'center'].includes(val);
    },
  },
  /** 防止滚动穿透 */
  preventScrollThrough: {
    type: Boolean,
    default: true,
  },
  /** 是否显示遮罩层 */
  showOverlay: {
    type: Boolean,
    default: true,
  },
  /** 对话框风格 */
  theme: {
    type: String,
    default: 'default',
    validator(val) {
      return ['default', 'info', 'warning', 'danger', 'success'].includes(val);
    },
  },
  /** 用于弹框具体窗口顶部的距离，优先级大于 placement */
  top: {
    type: [String, Number],
  },
  /** 控制对话框是否显示 */
  visible: Boolean,
  /** 控制对话框是否显示，非受控属性 */
  defaultVisible: Boolean,
  /** 对话框宽度，示例：320, '500px', '80%' */
  width: {
    type: [String, Number],
  },
  /** 对话框高度，示例：320, '500px', '80%' */
  height: {
    type: [String, Number],
  },
  /** 对话框层级，Web 侧样式默认为 2500，移动端和小程序样式默认为 1500 */
  zIndex: {
    type: Number,
  },
  /** 如果“取消”按钮存在，则点击“取消”按钮时触发，同时触发关闭事件 */
  onCancel: Function,
  /** 关闭事件，点击取消按钮、点击关闭按钮、点击蒙层、按下 ESC 等场景下触发 */
  onClose: Function,
  /** 点击右上角关闭按钮时触发 */
  onCloseBtnClick: Function,
  /** 对话框消失动画效果结束后触发 */
  onClosed: Function,
  /** 如果“确认”按钮存在，则点击“确认”按钮时触发，同时触发关闭事件 */
  onConfirm: Function,
  /** 按下 ESC 时触发事件 */
  onEscKeydown: Function,
  /** 对话框弹出动画效果结束后触发 */
  onOpened: Function,
  /** 如果蒙层存在，点击蒙层时触发 */
  onOverlayClick: Function,
};
